import React from 'react';
import PropTypes from 'prop-types';
import DeleteButton from '../../../v2/buttons/DeleteButton';
export default function ReferenceNumberTable({ referenceNumbers, label, onRemove, }) {
    function handleRemove(referenceNumber) {
        return function () {
            onRemove(referenceNumber);
        };
    }
    return (React.createElement("div", { className: "overflow-x-auto" },
        React.createElement("table", { className: "default-table" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, label),
                    React.createElement("th", null, "\u00A0"))),
            React.createElement("tbody", null, referenceNumbers.map((referenceNumber, i) => (React.createElement("tr", { key: i },
                React.createElement("td", null, referenceNumber),
                React.createElement("td", null,
                    React.createElement(DeleteButton, { onClick: handleRemove(referenceNumber) })))))))));
}
ReferenceNumberTable.propTypes = {
    referenceNumbers: PropTypes.arrayOf(PropTypes.string),
    onRemove: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
};
